import binaryExtensions from './binary-extensions.json' with {type: 'json'};

export default binaryExtensions;
